// Import saga helpers
import { call, put, all, takeLatest } from "redux-saga/effects";

// Import actionType
import { SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER } from "./actionType";

// Import action

import {
  searchContactPersonLookupByPhoneNumberSuccess,
  searchContactPersonLookupByPhoneNumberError,
} from "./action";
import { getContactPersonLookupListApiCall } from "../../helpers/fakebackend_helper";

//Search Contact Person Lookup by Phone Number
function* searchContactPersonLookupByPhoneNumberSaga(action) {
  try {
    const response = yield call(
      getContactPersonLookupListApiCall,
      action.payload
    );
    yield put(searchContactPersonLookupByPhoneNumberSuccess(response));
  } catch (error) {
    yield put(searchContactPersonLookupByPhoneNumberError(error));
  }
}

//Watcher function
function* watcherContactPersonLookupSaga() {
  yield all([
    takeLatest(
      SEARCH_CONTACT_PERSON_LOOKUP_BY_PHONE_NUMBER,
      searchContactPersonLookupByPhoneNumberSaga
    ),
  ]);
}

// Main Saga function
export default function* ContactPersonLookup() {
  yield all([watcherContactPersonLookupSaga()]);
}
